module.exports = __webpack_public_path__ + "img/contact-qr.696cf1f2.png";